import {React, observer, useEffect, toJS} from '@api'
import {useFilterStore} from '@modules/catalog'
import {LibraryItemConfigWrapper} from '@stores/catalog'
import {ICatalogFieldConfig} from '@stores/config'
import {Ref, RefObject, useRef} from 'react'
import {BoardFilterGroup} from './BoardFilterGroup'
import * as css from './ConfiguredFilterGroups.css'

export const ConfiguredFilterGroups = observer<{ library?: LibraryItemConfigWrapper }, HTMLDivElement> (function ConfiguredFilterGroups({library}, parentRef: RefObject<HTMLDivElement>) {
  const filter = useFilterStore(),
    {filterFields, expandedGroups} = filter,
    myRef = useRef<HTMLDivElement>(null),
    ref = parentRef ?? myRef

  // If we have an expanded filter scroll it into view on first mount
  useEffect(() => {
    if (ref?.current && !_.isEmpty(expandedGroups)) {
      const div = ref.current
      setTimeout(() => {
        div.querySelector(`[data-expanded='true']`)?.scrollIntoView()
      }, 50)
    }
  }, [ref?.current])

  // console.log(toJS(filterFields))
  return (
    <div ref={ref}
              className={css.root}
    >
    {filterFields.map((field, i) => <FilterGroupWrapper index={i} field={field} key={i} library={library}/>)}
  </div>)
}, {forwardRef: true})

const FilterGroupWrapper = observer<{ index: number, field: ICatalogFieldConfig, library?: LibraryItemConfigWrapper}>(function FilterGroupWrapper({field, index, library}) {
  const {data, uiStores, hasSearchText, stateFor} = useFilterStore(),
    uiStore = uiStores[field.field]

  const {fieldData, selectedData} = !data
                                    ? {fieldData: null, selectedData: null}
                                    : {fieldData: data[field.field], selectedData: data[`${field.field}_selected`]}

  // console.log({fieldData, selectedData, field})

  const count = (fieldData?.doc_count ?? 0) + (selectedData?.doc_count ?? 0)

  return (
    <div className={css.groupWrapper}
         data-has-search-result={hasSearchText && uiStore ? uiStore.titleMatchSearch != null || uiStore.valueSearchResults.length > 0 : undefined}
         data-has-header-search-result={hasSearchText && uiStore ? uiStore.titleMatchSearch != null : undefined}
         data-value-search-results={hasSearchText && uiStore ? uiStore.valueSearchResults.length : undefined}
         data-field={field.field}
         data-count={count}>
      <BoardFilterGroup key={field.field} index={index} field={field} library={library}/>
    </div>
  )
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/internal/ConfiguredFilterGroups.tsx